import { isEmpty } from 'lodash';
import { Dispatch } from 'redux';
import { apiErrorClear } from '../../../../../global/ducks/base-api';
import { getEmployment, getNonStipendiaryEmployment, patchNonStipPositionTitle, patchPositionTitle, postNonStipEmployment, postNonStipPositionTitle, postPositionTitle } from '../../../../../global/ducks/benadmin-api';
import { formatDate, MinDate, parseChanged } from '../../../../../global/helpers/form-data-helper';
import { ApiStatuses } from '../../../../../global/models/api-model';
import { Position } from '../employment-model';
import { dispatchSetEmployment, dispatchSetEmploymentFailed, dispatchSetNonStipendiaryEmployment, setNonStipendiaryEmployment, setUpdateNonStipPositionStatus, setUpdateStipPositionStatus, updateNonStipPosition, updateStipPosition } from '../employment-slice';
import { PositionFormValues } from './position-form-model';

export function postStipPositionRequest(dispatch: Dispatch<any>,
    employeeId: number | string,
    employmentId: number,
    savedValues: PositionFormValues,
    formValues: PositionFormValues,
    currentPosition: Position) {

    const changed = parseChanged(savedValues, formValues);

    const previousCompareDate = currentPosition?.end_date || currentPosition?.start_date || formatDate(MinDate);

    if (isEmpty(changed) || formatDate(formValues.start_date) <= formatDate(previousCompareDate)) {
        return;
    }

    dispatch(apiErrorClear());

    const { hire_date, end_date, ...payloadValues } = formValues;
    const postPayload = {
        position_title: {
            ...payloadValues,
            start_date: formatDate(formValues.start_date),
        },
    };

    dispatch(postPositionTitle(employeeId, employmentId, postPayload, () => {
        // on success, set success message and then fetch employment data (which has scheduled hours on it) again
        dispatch(setUpdateStipPositionStatus(ApiStatuses.Success));
        dispatch(getEmployment(employeeId, employmentId, dispatchSetEmployment(dispatch), () => dispatchSetEmploymentFailed(dispatch)));
    }));
}

export function patchStipPositionRequest(dispatch: Dispatch<any>,
    employeeId: number | string,
    employmentId: number | string,
    savedValues: PositionFormValues,
    formValues: PositionFormValues,
    currentPosition: Position) {

    const changed = parseChanged(savedValues, formValues);
    if (isEmpty(changed)) {
        return;
    }

    dispatch(apiErrorClear());

    const { hire_date, end_date, ...payloadValues } = formValues;
    const patchPayload = {
        position_title: {
            ...payloadValues,
            id: currentPosition?.id,
            start_date: formatDate(formValues.start_date),
        },
    };

    dispatch(patchPositionTitle(employeeId, employmentId, currentPosition?.id, patchPayload, (response) => {
        dispatch(updateStipPosition(response.data));
        dispatch(setUpdateStipPositionStatus(ApiStatuses.Success));
    }));
}

export function postNonStipEmploymentRequest(dispatch: Dispatch<any>, employeeId: number | string, employerClientNumber: string, formValues: PositionFormValues) {
    dispatch(apiErrorClear());

    const { hire_date, ...payloadValues } = formValues;
    const postPayload = {
        non_stipendiary_position: {
            employer_client_number: employerClientNumber,
            hire_date: formatDate(formValues.hire_date),
            current_position_title: {
                ...payloadValues,
                start_date: formatDate(formValues.start_date),
                end_date: formValues.end_date ? formatDate(formValues.end_date) : null,
            },
        },
    };

    dispatch(postNonStipEmployment(employeeId, postPayload, (response) => {
        dispatch(setNonStipendiaryEmployment(response.data));
        dispatch(setUpdateNonStipPositionStatus(ApiStatuses.Success));
    }));
}

export function postNonStipPositionRequest(dispatch: Dispatch<any>,
    employeeId: number | string,
    employmentId: number,
    employerClientNumber: string,
    savedValues: PositionFormValues,
    formValues: PositionFormValues) {

    const changed = parseChanged(savedValues, formValues);

    if (isEmpty(changed)) {
        return;
    }

    dispatch(apiErrorClear());

    const { hire_date, ...payloadValues } = formValues;
    const postPayload = {
        position_title: {
            ...payloadValues,
            start_date: formatDate(formValues.start_date),
            end_date: formValues.end_date ? formatDate(formValues.end_date) : null,
        },
    };

    dispatch(postNonStipPositionTitle(employeeId, employmentId, postPayload, () => {
        // on success, set success message and then fetch employment data (which has scheduled hours on it) again
        dispatch(setUpdateNonStipPositionStatus(ApiStatuses.Success));
        dispatch(getNonStipendiaryEmployment(employeeId, dispatchSetNonStipendiaryEmployment(dispatch, employerClientNumber)));
    }));
}

export function patchNonStipPositionRequest(dispatch: Dispatch<any>,
    employeeId: number | string,
    employmentId: number,
    savedValues: PositionFormValues,
    formValues: PositionFormValues,
    currentPosition: Position) {

    const changed = parseChanged(savedValues, formValues);
    if (isEmpty(changed)) {
        return;
    }

    dispatch(apiErrorClear());

    const { hire_date, ...payloadValues } = formValues;
    const patchPayload = {
        position_title: {
            ...payloadValues,
            start_date: formatDate(formValues.start_date),
            end_date: formValues?.end_date ? formatDate(formValues.end_date) : null,
        },
    };

    dispatch(patchNonStipPositionTitle(employeeId, employmentId, currentPosition?.id, patchPayload, (response) => {
        dispatch(updateNonStipPosition(response.data));
        dispatch(setUpdateNonStipPositionStatus(ApiStatuses.Success));
    }));
}